<template>
  <div
    class="help-widget"
    :class="type"
    @mouseover="showHelp = true"
    @mouseleave="showHelp = false"
  >
    <BaseIcon :icon="type" />
    <transition name="fadeUp">
      <div v-if="showHelp" class="help-widget__info-box">
        <div class="triangle"></div>
        <div class="help-widget__info-box__title">{{title}}</div>
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'BaseHelpWidget',
  props: {
    title: {
      type: String,
    },
    type: {
      type: String,
      default: 'help',
    },
  },
  data() {
    return {
      showHelp: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.help-widget {
  position: relative;
  display: inline-flex;
  cursor: pointer;
  z-index: 5;
  margin: 0 0.5rem;
  width: 2.4rem;
  height: 2.4rem;
  display: flex;
  align-items: center;
  justify-content: center;

  &.error {
    .icon {
      fill: $danger;
      width: 2rem;
      height: 2rem;
    }

    .help-widget__info-box__title {
      color: $danger;
      font-size: 1.2rem;
    }
  }

  .icon {
    fill: lighten($grey, 10%);
    width: 1.6rem;
    height: 1.6rem;
  }

  &__info-box {
    position: absolute;
    top: 3.2rem;
    left: -11.25rem;
    width: 25rem;
    min-height: 10rem;
    background-color: $dark;
    padding: 1.8rem;
    border-radius: 0.5rem;
    box-shadow: 0 0.5rem 1.5rem 0 rgba(37, 44, 97, 0.15), 0 0.2rem 0.4rem 0 rgba(93, 100, 148, 0.2);

    .triangle {
      position: absolute;
      top: -1.2rem;
      left: 0;
      right: 0;
      margin: 0 auto;
      width: 0;
      height: 0;
      border-left: 1rem solid transparent;
      border-right: 1rem solid transparent;
      border-bottom: 1.2rem solid $dark;
    }

    &__title {
      color: $company-color;
    }
  }
}
</style>